import { Injectable } from "@angular/core";
import { StorageService } from "./storage.service";
import { ProdutoFamiliaCheckboxViewModel, ProdutoFamiliaModel } from "src/app/shared/models/produto-familia.model";
import { GrupoImpressaoResponse } from "src/app/shared/models/impressora-config.model";

@Injectable({
    providedIn: 'root',
})
export class ImpressaoBehaviorService {
    public familiasImpressao: ProdutoFamiliaModel[] = [];

    constructor(
        private storageService: StorageService,
    ) {
        this.carregarFamiliaImpressao();
    }

    public async salvarFamiliaImpressao(familia: ProdutoFamiliaModel[]) {        
        await this.storageService.set('familiaProdutos', familia);
    }

    public async carregarFamiliaImpressao() {
        this.familiasImpressao = await this.obterFamilia();
    }
    
    public async obterFamilia(): Promise<ProdutoFamiliaModel[]> {
        const familiaProduto = await this.storageService.get('familiaProdutos');
        return familiaProduto != null ? familiaProduto : [];
    }
}